import {
  ArticleFetchConnectorApollo,
  ContentOnDemandConnectorApollo,
} from '@front-activerse/common-components';
import ArticleContainer from './ArticleContainer';
import { useTimestamp } from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';

const ArticlePage = () => {
  const { article } = useParams();
  const id = parseInt(article, 10);
  const { timestamp1 } = useTimestamp();

  return (
    <ArticleFetchConnectorApollo articleId={id}>
      {({ ...article }) => (
        <ContentOnDemandConnectorApollo>
          {({ ...loadContent }) => {
            return <ArticleContainer {...article} {...loadContent} key={timestamp1} />;
          }}
        </ContentOnDemandConnectorApollo>
      )}
    </ArticleFetchConnectorApollo>
  );
};

export default ArticlePage;
